<!--  -->
<template>
  <div class="loginBox">
    <img src="~@/assets/login/welcome.png" />
    <div class="loginInfo">
      <p class="login-title">绑定手机号</p>
      <h-form ref="form" :model="formData" :rules="formRules" inline>
        <h-form-item prop="phone">
          <div class="phone-div">+86</div>
          <h-input
            type="text"
            class="login-input phone-input"
            v-model="formData.phone"
            placeholder="请输入您的手机号"
          >
          </h-input>
        </h-form-item>
        <h-form-item prop="captcha_sms_code">
          <h-input
            type="text"
            class="login-input"
            v-model="formData.captcha_sms_code"
            placeholder="请输入短信验证码"
          >
          </h-input>
          <div
            @click="getSmsCheckCode()"
            class="message-div"
            :class="{
              'secondes-message':
                checkCodeActive && !resendShow && formData.phone,
            }"
          >
            {{ !resendShow ? "获取短信验证码" : `${seconds}秒后可重发` }}
          </div>
        </h-form-item>
        <h-form-item prop="captcha_img_code" v-if="imageCodeShow" key="5">
          <h-input
            class="login-input"
            type="text"
            v-model="formData.captcha_img_code"
            placeholder="请输入图形验证码"
          >
          </h-input>
          <img
            class="image-code"
            :src="imageCode.captcha_img_base64"
            @click="getCheckCode"
          />
        </h-form-item>
        <h-form-item v-else>
          <h-button
            :class="['login-button', { 'go-login': loginBtnState }]"
            @click="login()"
            :disabled="loginBtnState == false"
            >登 录</h-button
          >
        </h-form-item>
      </h-form>
    </div>
  </div>
</template>

<script>
import { CheckCode, smsCheckCode, wechatBindPhone } from "@/api/login.js"
import { queryParams, getUrlParam } from "@/utils"
export default {
  data() {
    const phoneRule = (rule, value, callback) => {
      if (value) {
        this.checkCodeActive = false
        if (!/^1[0-9]{10}$/.test(value)) {
          // 不合法
          return callback(new Error("请输入正确的手机号码"))
        }
      }
      this.checkCodeActive = true
      return callback()
    }
    return {
      /**
       * imageCodeShow: 是否显示图形验证码
       */
      formData: {},
      formRules: {
        phone: [{ validator: phoneRule, trigger: "change" }],
      },
      resendShow: false,
      checkCodeActive: false,
      seconds: 60,
      imageCodeShow: false,
    }
  },
  computed: {
    loginBtnState() {
      if (
        !(
          this.formData.phone &&
          this.formData.phone !== "" &&
          this.formData.captcha_sms_code &&
          this.formData.captcha_sms_code !== ""
        )
      )
        return false
      else return true
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  methods: {
    // 登录函数
    login() {
      this.getWechatBindPhone()
    },
    // 60s后重新发送验证码
    resendMessage() {
      this.resendShow = true
      this.timer = null
      this.seconds = 60
      this.timer = setInterval(() => {
        if (this.seconds == 0) {
          this.resendShow = false
          clearInterval(this.timer)
          return
        }
        this.seconds--
      }, 1000)
    },
    //获取图形验证码
    getCheckCode() {
      CheckCode()
        .then((res) => {
          this.imageCode = res
          console.log(res, this.imageCode)
        })
        .catch((error) => {})
    },
    //获取短信验证码
    getSmsCheckCode() {
      console.log()
      if (!this.checkCodeActive || this.formData.phone === "") {
        // 手机号码不合法
        return
      }
      if (this.resendShow) {
        // 获取短信验证码次数超显示图形验证码
        return
      } else {
        var params = { ...this.formData, captcha_sms_type: 5 }
        params = this.imageCodeShow
          ? {
              ...params,
              captcha_img_id: this.imageCode.captcha_img_id,
            }
          : params
        params = queryParams(params)
        smsCheckCode(params)
          .then((res) => {
            this.error_code = res.error_code
            if (res.error_code == "110004") {
              this.$hMessage.info(res.error_info)
              this.imageCodeShow = true
              this.getCheckCode()
            }
            if (res.error_code == "0") {
              clearInterval(this.timer)
              this.resendMessage()
            } else {
              this.getCheckCode()
            }
          })
          .catch((error) => {})
      }
    },
    // 微信绑定手机号
    getWechatBindPhone() {
      var url = getUrlParam(window.location.href, "service")
      url = url ? url : localStorage.getItem("backUrl")
      var params = {
        ...this.formData,
        success_redirect: url,
        wechat_auth_token: this.$route.query.wechat_auth_token,
      }
      wechatBindPhone(params)
        .then((res) => {
          if (res.error_code == "0") {
            this.$store.commit("SET_TOKEN", res.data.access_token)
            window.location.href = res.data.success_redirect
          } else {
            this.getCheckCode()
            this.tips = res.error_info
          }
        })
        .catch((error) => {})
    },
  },
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
}
</script>
<style lang="scss" scoped>
.loginBox {
  position: relative;
  width: 732px;
  height: 478px;
  display: flex;
  flex-direction: row;
  border-radius: 4px;
  background: #ffffff;
  justify-content: space-between;
  z-index: 1;
  .loginInfo {
    width: 320px;
    margin: 40px auto 0;
    .login-title {
      font-family: PingFangSC-Regular;
      font-size: 22px;
      color: #333333;
      height: 28px;
      text-align: center;
    }
    .phone-div {
      position: absolute;
      top: 0;
      left: 0;
      background: #f7f7f7;
      border-radius: 6px 0 0 6px;
      border: 1px solid #d9d9d9;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #333333;
      z-index: 5;
      width: 74px;
      height: 46px;
      line-height: 40px;
      text-align: center;
    }
    .message-div {
      position: absolute;
      top: 0;
      right: 0;
      // background: #3060ff;
      background: #e2e2e2;
      border: 1px solid #e2e2e2;
      width: 130px;
      height: 46px;
      // border: 1px solid #3060ff;
      border-radius: 0 6px 6px 0;
      text-align: center;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #ffffff;
      line-height: 44px;
      cursor: not-allowed;
      // cursor: pointer;
    }
    .secondes-message {
      background: #3060ff;
      border: 1px solid #3060ff;
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.loginBox {
  .loginInfo {
    .see-open,
    .see-close {
      cursor: pointer;
      width: 20px;
      height: 12px;
      position: absolute;
      right: 10px;
      top: 15px;
      z-index: 5;
    }
    .image-code {
      width: 104px;
      height: 46px;
      position: absolute;
      right: 0px;
      border: 1px solid #d9d9d9;
      border-radius: 0 6px 6px 0;
      cursor: pointer;
    }
    .login-button {
      width: 320px;
      height: 46px;
      border-radius: 6px;
      background: #e6e6e6;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      line-height: 18px;
    }
    .go-login {
      background: #3060ff;
    }
    .h-form-item {
      margin-bottom: 16px;
      height: 46px;
    }
    .is-save {
      height: 20px;
    }
    .login-input {
      .h-input {
        width: 320px;
        height: 46px;
        padding: 4px 12px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #9b9b9b;
        border-radius: 6px;
      }
    }
    .phone-input {
      .h-input {
        padding-left: 100px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/gtn/views/frontViews/components/wechatBind.vue